import React, { useState, useRef, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/icones/iconsmind/style.css';
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { useHover, UpdatingTooltip } from './../util/Utilitarios';
import { excluir } from './../util/AcessoApi'

import { set } from 'local-storage';
import { date } from 'yup';
import { ModalPadraoCadastro } from './Modais';
import { CadastroProdutoTipo } from '../areas/estoque/tipo-produto/pages/Cadastro';

function renderTooltip(props, nome, classTooltip) {
    delete props.show;
    return <Tooltip id={'tooltip ' + props.id ? props.id : 'tooltip ' + Math.random()} className={classTooltip} {...props}>{nome}</Tooltip>;
}

const BtnAcaoLink = (props) => {
    const { texto, icone, to } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone ml-1-between pt-5px">
            <OverlayTrigger
                popperConfig={{
                    modifiers: {
                        preventOverflow: {
                            enabled: false
                        }
                    }
                }}
                placement="bottom"
                delay={{ show: 25, hide: 25 }}
                overlay={(props) => renderTooltip(props, texto, classTooltip)}>
                <Link to={to} className={"icon-consulta btn-acao " + icone} />
            </OverlayTrigger>
        </div>
    )
}

const BtnAcao = (props) => {
    const { texto, icone, type } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone">
            {
                texto && <OverlayTrigger
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            }
                        }
                    }}
                    id={props.id ? props.id : Math.random()}
                    placement="bottom"
                    delay={{ show: 25, hide: 25 }}
                    overlay={(props) => renderTooltip(props, texto, classTooltip)}>

                    {props.loading ? <span className="spinner-border spinner-border-md" style={{ height: 20, width: 20 }} role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span> :
                        <button type={type && type || 'submit'} className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => props.action()} />}

                </OverlayTrigger>
                || <button type={type && type || 'submit'} className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => props.action()} />
            }
        </div>)
}

const Btn = (props) => {
    const { texto, icone } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone">
            {
                texto && <OverlayTrigger
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            }
                        }
                    }}
                    placement="bottom"
                    delay={{ show: 25, hide: 25 }}
                    overlay={(props) => renderTooltip(props, texto, classTooltip)}>
                    <button className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} />
                </OverlayTrigger>
                || <button className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} />
            }
        </div>)
}

const BtnAcaoExclusao = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone, type } = props
    const [hoverRef, isHovered] = useHover();

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div className="icone">

        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement={"bottom"}
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip + (contador === 1 ? " bottom-tooltip" : "")} id="popover-contained">{(contador === 1 ? "Tem certeza que deseja excluir?" : texto)}</UpdatingTooltip>
            }
        >

            <button ref={hoverRef} className={"btn-acao " + (contador == 1 ? " icon-Yes" : icone)} type={type && type || 'submit'} onClick={() => {
                if ((contador + 1) == 2) {
                    props.action();
                    setContador(0);
                }
                setContador(contador + 1);
            }
            } /></OverlayTrigger>

    </div>)
}

const LinkExclusaoTabelaPequena = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone } = props
    const [hoverRef, isHovered] = useHover();

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!loading) {
            setContador(0)
        }
    }, [loading])

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])



    return (<div style={{ display: 'inline' }}>
        <a ref={hoverRef} href="#" onClick={() => {
            if ((contador + 1) == 2) {
                setLoading(true);
                excluir(props.url, props.idItem, () => { props.acaoAposExclusao(); setLoading(false); }, () => { props.acaoAposErro && props.acaoAposErro(); setLoading(false); })
                setContador(0);
            }
            setContador(contador + 1);
        }} style={{ paddingLeft: '10px' }} class='link'><span className={(contador == 1 ? " icon-Yes" : icone)}></span> {loading ? 'aguarde...' : (contador == 0 ? 'excluir' : 'confirme')}</a>
    </div>)
}

const LinkAlteracaoTabelaPequena = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a href="#" onClick={() => {
                props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'alterar')}</a>
        </OverlayTrigger></div>)
}

const PopoverPadrao = (props) => {
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            onToggle={() => props.onToggle && props.onToggle()}
            target={`popover-positioned-${props.id}`}
            overlay={
                <Popover id={`popover-positioned-${props.id}`}>
                    <Popover.Title as="h3">{props.titulo}</Popover.Title>
                    <Popover.Content>
                        {props.conteudo}
                    </Popover.Content>
                </Popover>
            }
        >
            {props.children}
        </OverlayTrigger>
    )
}

const UpdatingPopover = React.forwardRef(
    ({ popper, children, show: _, ...props }, ref) => {
        useEffect(() => {
            popper.scheduleUpdate();
        }, [props.copiado, popper]);

        return (
            <Popover ref={ref} body {...props}>
                {children}
            </Popover>
        );
    },
);

const BtnAcaoModal = (props) => {

    const [showModal, setShowModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(null)

    const { texto, icone, type } = props
    const classTooltip = props.classTooltip

    const action = () => {
        setShowModal(true)
    }

    return (
        <div className="icone">
            {
                texto && <OverlayTrigger
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            }
                        }
                    }}
                    id={props.id ? props.id : Math.random()}
                    placement="bottom"
                    delay={{ show: 25, hide: 25 }}
                    overlay={(props) => renderTooltip(props, texto, classTooltip)}>

                    {props.loading ? <span className="spinner-border spinner-border-md" style={{ height: 20, width: 20 }} role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span> :

                        <button type={type && type || 'submit'} className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => { console.log('thius action '); action() }} />}


                </OverlayTrigger>

                || <button type={type && type || 'submit'} className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => { console.log('thius action '); action() }} />



            }
            <>    <ModalPadraoCadastro titulo={props.titulo} showModal={showModal} setShowModal={setShowModal}>
                {/* <CadastroProdutoTipo modal="true" setShow={setShowModal} setItemSelecionado={setItemSelecionado} funcaoAposSalvar={props.funcaoAposSalvar}></CadastroProdutoTipo> */}
                {props.modal}
            </ModalPadraoCadastro></>
        </div>)
}

const BtnAcaoConfirmacao = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone, type } = props
    const [hoverRef, isHovered] = useHover();
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div className="icone">

        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement={"bottom"}
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip + (contador === 1 ? " bottom-tooltip" : "")} id="popover-contained">{(contador === 1 ? props.mensagem : texto)}</UpdatingTooltip>
            }
        >
            {carregando ?
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span>
                :
                <button ref={hoverRef} className={"btn-acao " + (contador == 1 ? " icon-Yes" : icone)} type={type && type || 'submit'} onClick={() => {
                    if ((contador + 1) == 2) {
                        props.action(carregando, setCarregando);
                        setContador(0);
                    }
                    setContador(contador + 1);
                }
                } />
            }
        </OverlayTrigger>

    </div>)
}

const BtnGroup = (props) => <div className="btn-group"> {props.children} </div>
const Alterar = (props) => <BtnAcaoLink icone="icon-Pen" texto="Alterar" to={props.to} />
const Excluir = (props) => <BtnAcaoExclusao icone="icon-New-Trash" texto="Excluir" action={props.action} {...props} />
const Visualizar = (props) => <BtnAcaoLink icone="icon-File-Search" texto="Visualizar" to={props.to} {...props} />
const Imprimir = (props) => <BtnAcao icone="icon-Printer" texto="Imprimir" action={props.action} loading={props.loading} {...props} />
const Download = (props) => <BtnAcao icone="icon-Download" texto="Download PDF" to={props.to} {...props} />
const Voltar = (props) => <BtnAcao icone="icon-Arrow-Left" texto="Voltar" to={props.to} {...props} />
const Validar = (props) => <BtnAcao icone="icon-Checked-User" texto="Validar" action={props.action} {...props} />
const Reenvio = (props) => <BtnAcao icone="icon-Mail-Send" texto="Reenviar" action={props.action} {...props} />
const LinkExclusaoTabela = (props) => <LinkExclusaoTabelaPequena icone="icon-New-Trash" texto="Excluir" action={props.action} {...props} />
const LinkAlteracaoTabela = (props) => <LinkAlteracaoTabelaPequena icone="icon-Pen" texto="Alterar" action={props.action} {...props} />
const LinkExclusaoArrayTabela = (props) => <LinkAlteracaoTabelaPequena icone="icon-New-Trash" textoInline='excluir' texto="Excluir" action={props.action} {...props} />


export { BtnGroup, BtnAcao, Alterar, Excluir, Visualizar, Imprimir, Download, BtnAcaoLink, Voltar, Validar, Reenvio, Btn, LinkExclusaoTabela, LinkAlteracaoTabela, LinkExclusaoArrayTabela, PopoverPadrao, BtnAcaoModal, BtnAcaoConfirmacao }